import { createContext } from "react";

type MenuContextType = {
  isMenuOpen: boolean;
  toggleMenu: () => void;
  userName: string;
  setUserName: (userName: string) => void;
  mail: string;
  setMail: (mail: string) => void;
};

const MenuContext = createContext<MenuContextType>({
  isMenuOpen: false,
  toggleMenu: () => {},
  userName: "",
  mail: "",
  setUserName: () => {},
  setMail: () => {},
});

export { MenuContext };
